export default "__VITE_ASSET__sFaT8$6s__"